import React, { useCallback } from 'react';

import { Checkbox } from '@vtblife/uikit';
import Grid from '@vtblife/uikit-grid';

import type { QuizStepAnswer } from '@search/graphql-typings';

import type { QuizStepItemResult } from '../../service';

/* eslint-disable @typescript-eslint/naming-convention */
const GRID_VARIABLES = {
    '--row-gap-xs': '24px',
    '--row-gap-s': '24px',
    '--row-gap-m': '24px',
    '--row-gap-l': '24px',
    '--row-gap-xl': '24px'
};
/* eslint-enable @typescript-eslint/naming-convention */

const QuizBuilderStepAnswer = ({ fieldName, answer, stepItemResult, updateStepItemResult, isMobile }: {
    fieldName: string;
    answer: QuizStepAnswer;
    stepItemResult: QuizStepItemResult;
    updateStepItemResult: (value: QuizStepItemResult) => void;
    isMobile?: boolean;
}) => {
    const handleMultiChange = useCallback((isOn: boolean, value: string) => {
        const prevValue = stepItemResult[fieldName] ?? [];
        const newValue = isOn ? [ ...prevValue, value ] : prevValue.filter(v => v !== value);

        updateStepItemResult({ [fieldName]: newValue });
    }, [ fieldName, stepItemResult, updateStepItemResult ]);

    const handleSingleChange = useCallback((value: string) => {
        updateStepItemResult({ [fieldName]: [ value ] });
    }, [ updateStepItemResult, fieldName ]);

    return (
        <Grid
            cols={isMobile ? 1 : 3}
            variables={GRID_VARIABLES}
        >
            {answer.options.map((option, idx) => (
                <Grid.Cell
                    key={idx}
                    m={1}
                >
                    <Checkbox
                        radio={! answer.isMulti}
                        value={(stepItemResult[fieldName] ?? []).includes(option)}
                        onChange={
                            isOn => answer.isMulti ?
                                handleMultiChange(isOn, option) :
                                handleSingleChange(option)
                        }
                    >
                        {option}
                    </Checkbox>
                </Grid.Cell>
            ))}
        </Grid>
    );
};

export default QuizBuilderStepAnswer;
